import createIcon from '../../createIcon';

/**
 * @component @name RemoveRoad
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTguNzUgM0gxNi43NVYxMkgxOC43NVYzWiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTQuNzUgM0gyLjc1VjE5SDQuNzVWM1oiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xMS43NSAzSDkuNzVWN0gxMS43NVYzWiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTExLjc1IDlIOS43NVYxM0gxMS43NVY5WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTExLjc1IDE1SDkuNzVWMTlIMTEuNzVWMTVaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMjEuMjUgMTUuNDFMMTkuODQgMTRMMTcuNzUgMTYuMDlMMTUuNjYgMTRMMTQuMjUgMTUuNDFMMTYuMzQgMTcuNUwxNC4yNSAxOS41OUwxNS42NiAyMUwxNy43NSAxOC45MUwxOS44NCAyMUwyMS4yNSAxOS41OUwxOS4xNiAxNy41TDIxLjI1IDE1LjQxWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const RemoveRoad = createIcon('RemoveRoad', [
  ['path', { d: 'M18.75 3H16.75V12H18.75V3Z', key: '124afx' }],
  ['path', { d: 'M4.75 3H2.75V19H4.75V3Z', key: 'em07et' }],
  ['path', { d: 'M11.75 3H9.75V7H11.75V3Z', key: '2suxht' }],
  ['path', { d: 'M11.75 9H9.75V13H11.75V9Z', key: '1cfcdl' }],
  ['path', { d: 'M11.75 15H9.75V19H11.75V15Z', key: 'j2e8ku' }],
  [
    'path',
    {
      d: 'M21.25 15.41L19.84 14L17.75 16.09L15.66 14L14.25 15.41L16.34 17.5L14.25 19.59L15.66 21L17.75 18.91L19.84 21L21.25 19.59L19.16 17.5L21.25 15.41Z',
      key: '19uyua',
    },
  ],
]);

export default RemoveRoad;
